<div class="nav-env-message" *ngIf="environmentMessage">
    <div class="nav-env-message-inner">
        <span class="nav-env-message-icon fas fa-exclamation-circle"></span>
        <span>{{environmentMessage}}</span>
    </div>
</div>